<template>
  <section v-if="crew.length" id="crew" class="crew-section">
    <v-container>
      <p>The People Across the Years</p>
      <h2>The Reckon Crew</h2>
      <div class="crew-grid">
        <component
          :is="member.slug ? 'router-link' : 'article'"
          v-for="member in crew"
          :key="member.slug || member.name"
          :to="member.slug ? { name: 'passport', params: { employeeSlug: member.slug } } : null"
          class="crew-card"
        >
          <v-img v-if="member.headshot" :src="member.headshot | mediaSrc" alt="" aspect-ratio="1" class="crew-photo"></v-img>
          <v-icon v-else>mdi-account-circle-outline</v-icon>
          <div class="crew-copy">
            <span>{{ member.displayName || member.name }}</span>
            <strong v-if="member.title">{{ member.title }}</strong>
            <small>{{ member.attendanceCount }} re:Invent {{ member.attendanceCount === 1 ? 'trip' : 'trips' }}</small>
            <div class="crew-years">{{ member.years.join(' · ') }}</div>
          </div>
        </component>
      </div>
    </v-container>
  </section>
</template>

<script>
export default { name: 'RecurringCrewGrid', props: { crew: { type: Array, default: () => [] } } };
</script>

<style scoped>
.crew-section { background: #050505; border-top: 1px solid #242424; padding: 76px 0; scroll-margin-top: 68px; }
.crew-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2.2rem, 5vw, 3.2rem); margin: 0 0 28px; }
.crew-grid { display: grid; gap: 14px; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); }
.crew-card { align-items: center; background: #121212; border: 1px solid #2c2c2c; border-radius: 11px; color: #fff; display: grid; gap: 16px; grid-template-columns: 72px 1fr; overflow: hidden; padding: 14px; text-decoration: none; }
.crew-card:hover, .crew-card:focus-visible { border-color: #f0b13c; outline: none; }
.crew-photo { border-radius: 8px; width: 72px; }
.crew-card > .v-icon { color: #f0b13c; font-size: 3rem; }
.crew-copy { min-width: 0; }
.crew-copy > span { display: block; font-family: "Oswald", sans-serif; font-size: 1.25rem; font-weight: 800; }
.crew-copy strong { color: #aaa; display: block; font-size: 0.76rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.crew-copy small { color: #ddd; display: block; margin-top: 9px; }
.crew-years { color: #f0b13c; font-size: 0.73rem; font-weight: 800; margin-top: 4px; }
</style>
